import styled from "styled-components";

export const TableContractStyled = styled.div`
  .ant-table-thead {
    .ant-table-cell {
      background-color: white;
      color: #000000;
      border: none;
      font-weight: bold;
      border-bottom: 1px solid #d9d9d9;
    }
    .ant-table-cell::before {
      width: 0 !important;
      background-color: transparent !important;
    }
    .ant-table-cell:last-child {
      text-align: right;
      padding-right: 25px;
    }
    .ant-table-cell:first-child {
      text-align: right;
      padding-right: 10px;
    }
  }
  .ant-table-tbody {
    .ant-table-cell {
      background-color: white;
      color: #000000;
      font-size: 14px;
      line-height: 16px;
      padding-top: 13px;
      padding-bottom: 9px;
      border: 0;
    }
    .ant-table-cell:last-child {
      text-align: right;
      padding-right: 25px;
    }
    .ant-table-cell:first-child {
      font-weight: bold;
      text-align: right;
      padding-right: 10px;
    }
  }
`;
